






































import { Vue, Component, Prop, Watch, Emit, Ref } from "vue-property-decorator";
import { State, Getter, Action, Mutation } from "vuex-class";
import { IOrderDto } from "@/types/interface/IOrderDto";
import { OrderDto } from "@/types/impl/OrderDto";
import { getOrders } from "../../api/net/order";
import HistoryRow from "./components/history-row.vue";
import OrderBase from "./mixins/order-row-base";
import { IOrderCancellationRequestDto } from "../../types/interface/IOrderCancellationRequestDto";
import {
  event,
  getOrderStatusForRequestOrderList,
  toLocalTime,
  formatterDate
} from "../../libs/utils";
import store from "../../store/index";
type tabsType = { [key: string]: IOrderDto[] | IOrderCancellationRequestDto[] };
import Scroller from "@/components/Scroll.vue";
import {
  OrderItemType,
  OrderStatus,
  OrderItemSubType,
  DeliveryType,
  PaymentStatus,
  OrderPaymentType,
  PaymentType
} from "@/types/enum/OrderEnum";
import { IOrderPaging, IOrderPayload } from "../../types/interface/IOrderDto";
import { getOrderById, getOrdersWithCount } from "../../api/net/order";
import { IResultOrders } from "../../store/actions";

@Component({
  components: {
    HistoryRow,
    Scroller
  },
  name: "HistoryOrder"
})
export default class Order extends OrderBase {
  queryString: string = "";
  listHeight: number = 500;
  elementNode = "historyOrder";
  scrollToDetailElement: any = null;
  currentPage: number = 1;
  activePaging: boolean = false;
  total: number = 0;

  requestDate: string = new Date(new Date().toLocaleDateString()).toISOString();

  @Getter("historyOrder") orderList: IOrderDto[];

  public get totalPage(): number {
    return Math.ceil(this.total / 5);
  }

  public get moreThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.currentPage + 1;
      index < this.currentPage + 3 && index <= this.totalPage;
      index++
    ) {
      numberList.push(index);
    }
    return numberList;
  }

  public get lessThanCurrentPage(): number[] {
    let numberList = [];
    for (
      let index = this.currentPage - 1;
      index > this.currentPage - 3 && index > 0;
      index--
    ) {
      numberList.push(index);
    }
    return numberList.sort((a, b) => a - b);
  }

  @Action("handleHistoryOrders")
  private handleHistoryOrders!: (payload: IOrderDto[]) => Promise<void>;

  @Watch("requestDate")
  public async onRequestDateChanged(val: string, oldVal: string) {
    this.handleHistoryOrders([]);
    this.currentPage = 1;
    this.queryString = "";
    await this.getOrdersByPaging({
      page: this.currentPage,
      orderStatus: this.orderStatus,
      keyword: ""
    });
  }

  async toPage(page: number) {
    this.currentPage = page;
    store.commit("handleCurrentOrderPage", this.currentPage);
    store.commit("handleShowLoading", true);
    await this.getOrdersByPaging({
      page: this.currentPage,
      orderStatus: this.orderStatus,
      keyword: this.queryString
    });
  }

  public async getOrdersByPaging(payload: IOrderPayload) {
    let toParams = {
      DateTime: formatterDate(this.requestDate),
      page: this.currentPage,
      skip: 5,
      take: 5,
      // filterType: 0,
      merchId: "",
      keyword: this.queryString
    };
    let reslut = await this.getMerchorders(toParams, payload.orderStatus);
    if (Array.isArray(reslut)) {
      this.handleHistoryOrders(reslut);
    }
  }

  async getMerchorders(toParams: any, orderStatuses: OrderStatus[]) {
    let params = Object.assign(
      {
        orderStatuses
      },
      toParams
    );

    params["merchIds"] = store.state.merchIds;
    params["merchId"] = store.state.merchId;
    let { data } = await getOrdersWithCount(params["merchId"], params);
    this.total = data.result.total;
    return data.result.orders.reduce((arrOrder: IOrderDto[], x: IOrderDto) => {
      let isExistItemIndex = arrOrder.findIndex(o => o.id === x.id);
      if (isExistItemIndex > -1) {
        arrOrder.splice(isExistItemIndex, 1, x);
        return arrOrder;
      }
      return [...arrOrder, x];
    }, []);
  }

  public get historyOrderExpectedRefund() {
    return this.orderList
      .filter(x => !x.hasPendingApprovalRefund)
      .filter(
        x =>
          !(
            x.paymentStatus === PaymentStatus.Pending &&
            x.paymentType === PaymentType.Online &&
            x.orderStatus === OrderStatus.Cancelled
          )
      );
  }
  @Action("handleOrderList")
  private actionHandleOrderList!: (payload: IOrderPayload) => Promise<void>;

  async updateHistoryOrderList(orderId: string, merchId: string) {
    // await getOrderById(orderId);
    this.getOrdersByPaging({
      page: this.currentPage,
      orderStatus: this.orderStatus,
      keyword: this.queryString
    });
  }

  public get keyOfSearchHistoryOrder(): IOrderDto[] {
    return this.historyOrderExpectedRefund;
  }

  orderStatus: OrderStatus[] = [
    OrderStatus.Cancelled,
    OrderStatus.Pending,
    OrderStatus.WaitingForAcceptance,
    OrderStatus.Processing,
    OrderStatus.Ready,
    OrderStatus.Delivering,
    OrderStatus.Completed,
    OrderStatus.Rejected,
    OrderStatus.BadSale,
    OrderStatus.CancelRequested,
    OrderStatus.CancelRejected,
    OrderStatus.Refunding,
    OrderStatus.Refunded
  ];

  maxDatetime() {
    return new Date(new Date().getTime()).toISOString();
  }

  dateTimeInput() {
    return "text-align: center;border:solid 0.01rem #ddd;padding: 0.08rem 0.1rem;color: #444;";
  }

  limitSearch: boolean = false;

  search() {
    if (!this.limitSearch) {
      this.limitSearch = true;
      setTimeout(() => {
        this.limitSearch = false;
      }, 1000);
      this.currentPage = 1;
      this.handleHistoryOrders([]);
      this.getOrdersByPaging({
        page: 1,
        orderStatus: this.orderStatus,
        keyword: this.queryString
      });
    }
  }

  handleSearchKeydown(e: any) {
    if (e.keyCode === 13) {
      this.search();
    }
  }

  resize() {
    this.listHeight = document.body.offsetHeight - 200;
    window.onresize = () => {
      this.listHeight = document.body.offsetHeight - 200;
    };
  }

  mounted() {
    this.resize();
    // this.getOrdersByPaging({
    //   page: this.currentPage,
    //   orderStatus: this.orderStatus,
    //   keyword: ""
    // });
  }
}
